export default {
  autocompletePhases: [],
}